import React from 'react';
import { getGravatar } from '../../lib/utils';
import Image from 'next/image';

const NameInitialWrapper = ({ children, name, email, size='40px' }) => {
    const gravatar = getGravatar(email, name);
    
    return (
        <div className={`h-[${size}] w-[${size}]`}>
            {/* {children} */}
            <Image src={gravatar} alt={name} width={32} height={32} draggable='false' className='rounded-full w-full h-full'/>
        </div>
    )
};
export default NameInitialWrapper;